<div class="error-page error-page--centered">
  <div class="error-page__logo">
    <img src="assets/img/logo-veolia.png" alt="Logo Veolia" />
  </div>
  <div>
    <h2 class="error-page__title">401 — Autorisation requise</h2>
  </div>
  <p class="error-page__message">
    Vous n'êtes pas autorisé à accéder à cette ressource. Veuillez vous connecter ou contacter un
    administrateur.
  </p>
  <div class="error-page__actions">
    <a class="btn btn-primary" [routerLink]="['/login']">Se connecter</a>
  </div>
</div>
